import React from "react";
import { useSelector } from "react-redux";
import { Typography } from "antd";
import LocationModel from "../../../../../viewModels/Location/LocationModel";
import { makeSelectLanguage } from "../../../../../containers/App/selectors";
import { getIconByLocationType } from "../../../../pickers/LocationPicker/locationIcons";
import getLocalizedName from "../../../../../utils/getLocalizedName";

type Props = {
  location: LocationModel;
};

const LocationWithIcon = React.memo(({ location }: Props) => {
  const lang = useSelector(makeSelectLanguage());
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <i style={{ display: "flex" }}>{getIconByLocationType(location.type)}</i>
      {location.country && <Typography.Text strong>{getLocalizedName(location.country, lang)}</Typography.Text>}
      <Typography.Text>{getLocalizedName(location, lang)}</Typography.Text>
    </div>
  );
});

export default LocationWithIcon;
